import { Navigate, Route, Routes } from "react-router-dom";

import Schedule from "./Schedule/Schedule";
import { ScheduleEdit } from "./ScheduleEdit/ScheduleEdit";
import { ScheduleView } from "./ScheduleView/ScheduleView";
import { PrivateRoute } from "../../keycloak";
import { UserRoles } from "../../constants/userRoles";

export function SchedulingAndExecution() {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.JOB_VIEW],
            }}
          />
        }
      >
        <Route path="/schedule" element={<Schedule />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.JOB_UPDATE],
            }}
          />
        }
      >
        <Route path="/schedule/:scheduleId/edit" element={<ScheduleEdit />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.JOB_VIEW],
            }}
          />
        }
      >
        <Route path="/schedule/:scheduleId/view" element={<ScheduleView />} />
      </Route>
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}
